angular.module("ainapp")
    .controller("leadController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Lead";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Statuses = [];
            MainService.getStatusbyType('Lead').then(function (response) {
                angular.forEach(response.data, function (e) {
                    if (e.Name != "New" && e.Name != "Converted") {
                        $scope.Statuses.push(e);
                    }
                })
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })



            $scope.Init = function () {
                $scope.TokenInfo = AuthenticationService.getTokenInfo();
                $scope.load = 0;
            }
            $scope.Init();




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.IsOpportunity = false;
                        o.data.EmployeeId = $scope.TokenInfo.EmployeeId;
                        MainService.LeadsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            CustomerName: {
                                type: "string",
                                editable: false,
                            },
                            RefNo: {
                                type: "string",
                                editable: false,
                            },

                            PlannedMeetingDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },

                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Status.Name": {
                                type: "string",
                                editable: false,
                            },
                            "LeadType.Name": {
                                type: "string",
                                editable: false,
                            },
                            CustomerMobileNo1: {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "RefNo",
                        title: "Ref No",
                        headerTemplate: "{{LanguageData.RefNo}}",
                            },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        headerTemplate: "{{LanguageData.Date}}",
                            },
                    {
                        field: "Status.Name",
                        title: "Status",
                        headerTemplate: "{{LanguageData.Status}}",
                                 },
                    {
                        field: "LeadType.Name",
                        title: "Lead Type",
                        headerTemplate: "{{LanguageData.LeadType}}",
                                 },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                        },
                    {
                        field: "CustomerName",
                        title: "Customer",
                        headerTemplate: "{{LanguageData.Customer}}",
                        },
                    {
                        field: "CustomerMobileNo1",
                        title: "Mobile No",
                        headerTemplate: "{{LanguageData.MobileNo}}",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button> <button class=' btn-default btn-sm fa fa-arrow-right'  ng-click='ConvertLead(dataItem)'></button> <button class=' btn-default btn-sm fa fa-save'  ng-click='update(dataItem)'></button>",
                        width: '120px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#myModal2").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteLead($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $state.go("editLead", {
                    LeadId: data.Id
                })
            };


            $scope.SelectedDataForConvert = {};
            $scope.ConvertLead = function (data) {
                $scope.SelectedDataForConvert = data;
                $("#convertModel").modal("show");
            }

            $scope.convertWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ConvertLead($scope.SelectedDataForConvert.Id).then(function (response) {
                    if (response.data) {
                        $('#convertModel').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForConvert = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                });
            }


            $scope.SelectdDataForUpdate = {};
            $scope.update = function (data) {
                $scope.SelectdDataForUpdate = data;
                $("#updatemodal").modal("show");
            };

            $scope.updateConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateLeadStatus($scope.SelectdDataForUpdate).then(function (response) {
                    if (response.data) {
                        $('#updatemodal').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectdDataForUpdate = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                });
            }


                }])
